import { ComponentProps } from 'react';
import Icon from '../Icon';
import favourite from './favourites.svg';

type FavouriteNames =
  | 'account_balance'
  | 'account_circle'
  | 'add'
  | 'arrow_back'
  | 'arrow_down-left'
  | 'arrow_downward'
  | 'arrow_drop_down'
  | 'arrow_drop_up'
  | 'arrow_forward'
  | 'arrow_left'
  | 'arrow_right'
  | 'arrow_up-right'
  | 'arrow_upward'
  | 'calendar_today'
  | 'cancel'
  | 'check_circle_outline'
  | 'check_circle'
  | 'check'
  | 'chevron_down'
  | 'chevron_left'
  | 'chevron_right'
  | 'chevron_up'
  | 'close'
  | 'delete'
  | 'description'
  | 'error_outline'
  | 'error'
  | 'favorite_border'
  | 'favorite'
  | 'female'
  | 'file_download'
  | 'forum'
  | 'home'
  | 'ios_share'
  | 'launch'
  | 'list_alt'
  | 'male'
  | 'mode_edit'
  | 'more_horiz'
  | 'more_vert'
  | 'notifications_off'
  | 'notifications'
  | 'people'
  | 'person'
  | 'place'
  | 'placeholder'
  | 'search'
  | 'send'
  | 'settings'
  | 'star_border'
  | 'star'
  | 'swipe_left'
  | 'swipe_right'
  | 'toll'
  | 'upload'
  | 'wallet'
  | 'warning_amber'
  | 'warning'
  | 'watch_later'
  | 'work';

interface FavouritesIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: FavouriteNames;
}

export function FavouriteIcon(props: FavouritesIconProps) {
  return (
    <Icon link={favourite} {...props} data-name="test" />
  );
}
